export function normalizeCheckoutTextsPayload(data) {
  if (
    data &&
    typeof data === "object" &&
    data.textoCarrito &&
    typeof data.textoCarrito === "object" &&
    !Array.isArray(data.textoCarrito)
  ) {
    return data.textoCarrito;
  }
  return data;
}

function resolveCheckoutArray(value, defaultValue, treatEmptyArraysAsMissing) {
  if (!Array.isArray(value)) {
    return defaultValue;
  }
  if (treatEmptyArraysAsMissing && value.length === 0) {
    return defaultValue;
  }
  return value;
}

export function mergeCheckoutTextsWithDefaults(data, defaults, options = {}) {
  const { treatEmptyArraysAsMissing = true } = options;
  const source = normalizeCheckoutTextsPayload(data) ?? {};

  return {
    tituloPagina: source.tituloPagina ?? defaults.tituloPagina,
    subtituloPagina: source.subtituloPagina ?? defaults.subtituloPagina,
    caracteristicas: resolveCheckoutArray(
      source.caracteristicas,
      defaults.caracteristicas,
      treatEmptyArraysAsMissing,
    ),
    beneficios: resolveCheckoutArray(
      source.beneficios,
      defaults.beneficios,
      treatEmptyArraysAsMissing,
    ),
    textoSeguridad: source.textoSeguridad ?? defaults.textoSeguridad,
    tituloCarritoVacio: source.tituloCarritoVacio ?? defaults.tituloCarritoVacio,
    descripcionCarritoVacio:
      source.descripcionCarritoVacio ?? defaults.descripcionCarritoVacio,
  };
}
